module.exports = __webpack_public_path__ + "static/media/icon-pix-parcelado.7348cc23.svg";